/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Policy_Destructive_Confirm_Load_ErrorInputs */



/**
* | output |
* | --- |
* | "Could not load the marked agents." |
*
* @param {Agent_Policy_Destructive_Confirm_Load_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_policy_destructive_confirm_load_error = /** @type {((inputs?: Agent_Policy_Destructive_Confirm_Load_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Policy_Destructive_Confirm_Load_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die markierten Agenten konnten nicht geladen werden.")
	return /** @type {LocalizedString} */ ("Could not load the marked agents.")
});